import { useActiveProjectQuery } from "src/hooks/useActiveProjectQuery";
import { useInitials } from "./useInitials";
import classNames from "classnames";
import type { BooleanState } from "src/types/BooleanState";

export function ProjectName(props: { expanded: BooleanState }) {
  const projectQuery = useActiveProjectQuery();
  const project = projectQuery.data;
  const name = project?.name ?? "";
  const initials = useInitials(name);
  const label = props.expanded.isOff ? initials : name;
  return (
    <div
      className={classNames(
        "text-subtitle-1 text-neutral-8 flex w-full flex-1 transition-all",
        props.expanded.isOn && "px-3 justify-start",
        props.expanded.isOff && "justify-center"
      )}
    >
      <span className="h-full">{label}</span>
    </div>
  );
}
